import { render, staticRenderFns } from "./SelectCriteria.vue?vue&type=template&id=99bc9a10"
import script from "./SelectCriteria.vue?vue&type=script&lang=ts"
export * from "./SelectCriteria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports